<template>
  <nav
    class="relative flex justify-between items-center container mt-6"
    style="background: #f0f8ff00"
  >
    <a
      class="text-3xl font-bold leading-none hidden lg:flex"
      href="javascript:;"
    >
      <img
        v-if="urlOriginIsBrandIn"
        alt="COTIZADOR"
        class="h-2"
        :src="require(`@/assets/images/COT-img/logo-brand-in.png`)"
      />
      <img
        v-else
        :src="require(`@/assets/images/COT-img/logo.png`)"
        class="h-2"
        alt="producto"
      />
    </a>
  </nav>
</template>

<script>
export default {
  computed: {
    urlOriginIsBrandIn() {
      return this.$store.getters['main/urlOriginIsBrandIn']
    }
  }
}
</script>
